import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3001";

const api = axios.create({
  baseURL: `${apiUrl}/api`,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
